import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import config from 'config';
import { loggedInUser, userToken } from '@/services/authentication';

const channels = [];

const subscribeToOwnPrivateChannel = (instance, store) => {
    const channelName = `user.${loggedInUser().id}.channel`;
    instance
        .private(channelName)
        .listen('.user.changed', ({ user }) => store.dispatch('authentication/userUpdated', user));

    return () => instance.leave(channelName);
};

const subscribeToOrganizationPrivateChannel = (instance, store) => {
    const channelName = `organization.${loggedInUser().organization_id}.channel`;
    instance
        .private(channelName)
        .listen(
            '.subscription.changed',
            ({ subscription }) => store.dispatch('authentication/userSubscriptionUpdated', subscription),
        )
        .listen(
            '.inspection-count.changed',
            ({ organization }) => store.dispatch('authentication/userInspectionCountUpdated', organization),
        );

    return () => instance.leave(channelName);
};

export default {
    start: (store) => {
        if (!config.pusherKey) {
            const echoInstance = new Echo({
                broadcaster: 'null',
            });
            return echoInstance;
        }

        Pusher.logToConsole = config.PUSHER_LOG_TO_CONSOLE || false;
        const client = new Pusher(config.pusherKey, {
            cluster: 'eu',
            forceTLS: true,
            encrypted: true,
            authEndpoint: config.pusherAuthEndpoint,
            auth: {
                headers: {
                    Authorization: `Bearer ${userToken().token}`,
                },
            },
        });

        const echoInstance = new Echo({
            broadcaster: 'pusher',
            client,
        });

        channels.push(subscribeToOwnPrivateChannel(echoInstance, store));
        channels.push(subscribeToOrganizationPrivateChannel(echoInstance, store));

        return echoInstance;
    },
    end: () => channels.forEach((unsubscribeCallback) => unsubscribeCallback()),
};
